export default __webpack_public_path__ + "media/images/favicon-b73ae63e51221c37e74ef12c53274140.ico";